import { externalIntegrationsRepositorySingleton } from '@warehouse/object-browser/infra';

export function useExternalIntegrations() {
	const repo = externalIntegrationsRepositorySingleton.get();
	return repo.getAvailable();
}
